import { render, staticRenderFns } from "./RoomNameChanged.vue?vue&type=template&id=07c7faaa&"
import script from "./RoomNameChanged.vue?vue&type=script&lang=js&"
export * from "./RoomNameChanged.vue?vue&type=script&lang=js&"
import style0 from "./RoomNameChanged.vue?vue&type=style&index=0&id=07c7faaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports